import React, { Component } from 'react';

import { t } from '../../../../locales';
import InnerWrapper from '../../../../components/InnerWrapper/';
import { connect } from 'react-redux';

import './styles.scss';

import { getEmmaAppLink } from '../../selectors/vhisSelectors';

// image
import IconAppEmma from '../../../../assets/images/icon--app--emma.png';
import { addCorpWebIndicator } from '../../../../utils/emmaUrlConverter';
import { getCorpWebIndicatorConfig } from '../../../emma-webview/selectors/webviewSelector';

interface EnjoyAppProps {
  downAppLink: string;
}

class EnjoyApp extends Component<EnjoyAppProps> {
  render() {
    return (
      <div className="enjoy-app">
        <InnerWrapper>
          <div className="enjoy-app__wrapper">
            {/* icon start */}
            <div className="enjoy-app__icon">
              <img src={IconAppEmma} alt="" />
            </div>
            {/* icon end */}
            {/* txt start */}
            <div className="enjoy-app__txt">
              <p className="enjoy-app__txt__title">{t(`ENJOYAPP_TITLE`)}</p>
              <p className="enjoy-app__txt__content">{t(`ENJOYAPP_CONTENT`)}</p>
            </div>
            {/* txt end */}
            {/* link start */}
            <div className="enjoy-app__link">
              <a
                className="enjoy-app__btn"
                href={this.props.downAppLink}
                target="_blank"
                data-enable-ga
                data-ga-type="link"
                rel="noreferrer"
              >
                {t('VHIS_DOWNLOAD')}
              </a>
            </div>
            {/* link end */}
          </div>
        </InnerWrapper>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const appLink = addCorpWebIndicator({
      url: getEmmaAppLink(state),
      ...getCorpWebIndicatorConfig(state),
    });
    return {
      downAppLink: appLink,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  EnjoyApp.mapStateToProps,
  EnjoyApp.mapDispatchToProps,
)(EnjoyApp);
